import "./DDA.css";

const DownloadPatientApp = () => {
  return (
    <div className="download-doctor-app-body">
      <h1 className="header-text">EHS (Patient Application)</h1>
      <a href="/patient-app/Patient Application.apk" className="download-btn" download>
        Download
      </a>
      <p>Click the button above to download the EHS Patient Application.</p>
    </div>
  );
};

export default DownloadPatientApp;
